import request from '@/utils/request'

// =============== 手机端标签绑定 ===============

/**
 * @describe 分页查看绑定记录
 * @param areaCodeCity
 * @param areaCodeDistrict
 * @param areaCodeSubdistrict
 * @param villageCode
 * @param printRecordId 打印记录下的绑码记录（可从打印记录进入）
 * @param bindLabAllotId 分配规则下的绑码记录（可从分配记录进入）
 * @param certificateRecordId 合格证下的绑码记录（可从合格证记录进入）
 * @param bindBatchNo 绑码批次
 * @param entName 企业名称
 * @param kssj
 * @param jssj
 * @param pageNum 1
 * @param pageSize 20
 */
export function pageBindLabBind(query) {
  return request({
    url: 'bind/pageBindLabBind.do',
    method: 'GET',
    params: query
  })
}

/**
 * @describe 分页查看绑定记录标签明细
 * @param bindLabBindId  绑定记录id
 * @param bindCode 条码值
 * @param printRecordId 打印记录下的绑码明细（可从打印记录进入）
 * @param certificateRecordId 合格证下的绑码明细（可从合格证记录进入）
 * @param pageNum 1
 * @param pageSize 20
 */
export function pageBindLabBindDetail(query) {
  return request({
    url: 'bind/pageBindLabBindDetail.do',
    method: 'GET',
    params: query
  })
}


/**
 * @describe 绑定绑码标签
 * @param certificateRecordId  // 合格证记录id
 * @param startBindCode // 绑码值-起始
 * @param endBindCode // 绑码值-结束
 * @param bindCount // 绑定数量
 */
export function saveBindLabBind(query) {
  return request({
    url: 'bind/saveBindLabBind.do',
    method: 'POST',
    data: query
  })
}

/**
 * @describe 撤销绑定记录（如果已被扫描查询，则不能撤销）
 * @param bindLabBindId 绑定记录id
 */
export function revokeBindLabBind(query) {
  return request({
    url: 'bind/revokeBindLabBind.do',
    method: 'POST',
    data: query
  })
}


/**
 * @describe 根据绑码查询合格证信息 - 手机端扫码后赋码的页面
 * @param bindCode 条码值
 * @param securityCode 防伪码
 * @param checkSecurityCode (true:防伪码 / false:防伪码不要)
 */
export function searchByBindCode(query) {
  return request({
    url: 'scan/searchByBindCode.do',
    method: 'GET',
    params: query
  })
}



